/** @jsx jsx */
import { jsx } from "theme-ui"
import Img from "gatsby-image/withIEPolyfill"
import PropTypes from "prop-types"

import Link from "./link"

const PageTeaser = ({
  image,
  imageAlt,
  children,
  heading,
  pageLink,
  linkText,
  linkTarget,
  mode,
  download,
  currentLanguage,
  seoLinks,
}) => (
  <div
    className="page-teaser"
    data-mode={mode}
    sx={{
      bg: mode ? `modes.${mode}.primary` : "primary",
      my: 3,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Img
      fluid={{
        ...image,
        sizes: "(min-width: 824px) 432px, 100vw",
      }}
      alt={imageAlt}
    />
    <div
      sx={{
        textAlign: "center",
        color: "background",
        fontSize: 1,
        p: 3,
        position: "relative",
        flex: 1,
        "& p": {
          marginBottom: 0,
        },
        pb: linkText ? "71px" : 3,
      }}
    >
      <h2
        sx={{
          py: 0,
          m: 0,
          fontWeight: 1,
          hyphens: "auto",
        }}
      >
        {heading}
      </h2>
      {children}
      <div
        sx={{
          width: "calc(100% - 32px)",
          display: linkText ? "block" : "none",
          position: "absolute",
          bottom: 3,
        }}
      >
        <Link
          to={pageLink}
          download={download}
          target={linkTarget}
          language={currentLanguage}
          seoLinks={seoLinks}
          sx={{
            display: "inline-block",
            variant: "styles.ghostButton",
            border: "solid 1px #fff",
            color: "#fff",
            py: "7px",
            px: "40px",
            marginTop: 3,
            "&:hover": {
              bg: "#fff",
              color: mode ? `modes.${mode}.primary` : "primary",
            },
          }}
        >
          {linkText}
        </Link>
      </div>
    </div>
  </div>
)

PageTeaser.propTypes = {
  image: PropTypes.object.isRequired,
  imageAlt: PropTypes.string,
  children: PropTypes.node,
  heading: PropTypes.string.isRequired,
  pageLink: PropTypes.string,
  linkText: PropTypes.string,
  download: PropTypes.bool,
  linkTarget: PropTypes.string,
  mode: PropTypes.oneOf(["", "pharma", "food", "environment"]),
  currentLanguage: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
}

PageTeaser.defaultProps = {
  mode: "",
  download: false,
  seoLinks: {},
}

export default PageTeaser
